import styled, { css } from 'styled-components';

import { Z_INDEX_BACKDROP } from '@/config/variables';

const Backdrop = styled.div<{ show: boolean }>`
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: ${Z_INDEX_BACKDROP};
  background-color: #000;
  max-width: 1440px;

  ${({ show }) =>
    show
      ? css`
          opacity: 0.15;
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `};

  transition: opacity 0.5s ease;
`;

export { Backdrop };
